import { makeModuleStateSelector } from "@client/content/selectors";
import { createSelector } from "reselect";
import { defaultState, previewState } from "./reducer";
import { type ProductDetail } from "./types";

export const localStateSelector = makeModuleStateSelector<ProductDetail.AppState>(defaultState, previewState);

export const localStateProductSelector = createSelector(localStateSelector, (ls) => ls.product);
export const localStateProductVariantsSelector = createSelector(localStateSelector, (ls) => ls.productVariants);
